(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneCallSearch', PhoneCallSearch);

    PhoneCallSearch.$inject = ['$resource'];

    function PhoneCallSearch($resource) {
        var resourceUrl =  'api/_search/phone-calls/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
